import { render, staticRenderFns } from "./ClientListItem.vue?vue&type=template&id=402b2364"
import script from "./ClientListItem.vue?vue&type=script&lang=js"
export * from "./ClientListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports